import {
  Box,
  Paper,
  Stack,
  Typography,
  TextField,
  InputAdornment,
  Divider,
  Button,
  Alert,
  Grid,
} from '@mui/material'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import SaveIcon from '@mui/icons-material/Save'
import { ClockIcon } from '@mui/x-date-pickers'

const ShiftClockSettingsForm = ({ values, setValues }) => {
  const fields = [
    {
      key: 'earlyStartWindowMinutes',
      label: 'Early clock-in window',
      helper:
        'How many minutes before the planned shift start staff can clock in.',
    },
    {
      key: 'onTimeGraceMinutes',
      label: 'On-time grace period',
      helper:
        'Grace period either side of the planned start time considered on time.',
    },
    {
      key: 'lateStartAfterMinutes',
      label: 'Late start threshold',
      helper:
        'How many minutes after shift start before staff are marked late.',
    },
    {
      key: 'earlyFinishBeforeMinutes',
      label: 'Early finish window',
      helper:
        'How many minutes before the planned shift end staff can clock out.',
    },
    {
      key: 'lateFinishAfterMinutes',
      label: 'Late finish / overrun threshold',
      helper:
        'How many minutes after shift end before it is treated as an overrun.',
    },
  ]

  const handleChange = (key, value) => {
    setValues((prev) => ({
      ...prev,
      [key]: value === '' ? '' : Number(value),
    }))
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Stack spacing={3}>
        <Box>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 2,
                bgcolor: 'primary.main',
                color: 'primary.contrastText',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <AccessTimeIcon />
            </Box>

            <Box>
              <Typography variant="h6">Shift Clock Settings</Typography>
              <Typography variant="body2" color="text.secondary">
                Control clock-in windows, grace periods, late starts and
                overruns.
              </Typography>
            </Box>
          </Stack>
        </Box>

        <Alert severity="info" sx={{ borderRadius: 2 }}>
          These settings affect how attendance is classified against planned
          shift start and finish times.
        </Alert>

        <Divider />

        <Box>
          <Grid container spacing={2}>
            {fields.map((field) => (
              <Grid item xs={12} md={6} lg={4} key={field.key}>
                <TextField
                  label={field.label}
                  type="number"
                  value={values?.[field.key] ?? ''}
                  onChange={(e) => handleChange(field.key, e.target.value)}
                  helperText={field.helper}
                  fullWidth
                  inputProps={{ min: 0 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <ClockIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">mins</InputAdornment>
                    ),
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Stack>
    </Paper>
  )
}

export default ShiftClockSettingsForm
